import React from 'react';

import {
  QueueTabBar,
  routeDirectory
} from 'modules';

import { useNavigate } from 'react-router-dom';
import * as shared from '../shared';
import * as types from '../types';
import * as dataService from './dataService';



const TabBar = QueueTabBar.genTabBarComponent({
  tabs: shared.tabs
});



export interface IProps {
  filter: types.IFilter;
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.useQuery(props.filter);
  const params = shared.useActivityParams();
  const navigate = useNavigate();



  return (
    <TabBar
      loading={queryTuple.loading}
      value={params.tabId}
      tabId2ItemCount={{
        newSalesOrders: queryTuple.data.newSalesOrdersCount,
        awaitingApproval: queryTuple.data.awaitingApprovalCount,
        awaitingFulfillment: queryTuple.data.awaitingFulfillmentCount,
        awaitingPayment: queryTuple.data.awaitingPaymentCount,
        inTransit: queryTuple.data.inTransitCount
      }}
      onChange={tabId => {
        navigate(routeDirectory.admin.orders.path(
          props.filter.salesChannel,
          tabId,
          props.filter.storeId
        ), {
          replace: true
        });
      }} />
  );
};
